import { request } from '@/utils/request'

export function getResultList(params) {
  return request({
    url: `examUser/${params.pageNum}/${params.pageSize}`,
    method: 'post',
    data: params.condition
  })
}

// 查询成绩
export function getScore(id) {
  return request({
    url: `/examUser/${id}`,
    method: 'get'
  })
}
// 查询模版
export function getScoreBg(id) {
  return request({
    url: `/exam-setting/exam/${id}`,
    method: 'get'
  })
}
